<template>
  <v-card flat tile class="d-flex flex-column text-left">
    <v-btn
      style="justify-content: space-between; text-transform: unset"
      x-large
      text
      @click="handleSelectOption('retention')"
    >
      <span class="d-flex">
        <v-icon>mdi-chart-line</v-icon>
        <p class="menuText">
          {{ $t('message.pages.video.metricsPage.retention') }}
        </p>
      </span>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn
      style="justify-content: space-between; text-transform: unset"
      x-large
      text
      @click="handleSelectOption('traffic')"
    >
      <span class="d-flex">
        <v-icon>mdi-chart-box-outline </v-icon>
        <p class="menuText">
          {{ $t('message.pages.video.metricsPage.theVideoTraffic') }}
        </p>
      </span>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn
      style="justify-content: space-between; text-transform: unset"
      x-large
      text
      @click="handleSelectOption('views')"
    >
      <span class="d-flex">
        <v-icon>mdi-eye-outline</v-icon>
        <p class="menuText">
          {{ $t('message.pages.video.metricsPage.views') }}
        </p>
      </span>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'VideoMetricsOption',
  data: () => ({
    isBeta: false,
  }),
  props: {
    handleSelectOption: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState(['video']),
  },
  mounted() {
    this.isBeta = location.search.match('beta')
  },
  methods: {
    ...mapActions('video', ['getVideoPlayer']),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
    ]),
  },
}
</script>

<style>
.circle {
  margin-right: 5px;
  margin-top: -2px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: rgb(30 216 231);
  display: inline-block;
}
</style>

<style lang="scss" scoped>
.menuText {
  background-color: rgba(#fff, 0) !important;
}
</style>
